/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { Location } from "./Location";
import {
  LocationFromJSON,
  LocationFromJSONTyped,
  LocationToJSON,
  LocationToJSONTyped,
} from "./Location";

/**
 *
 * @export
 * @interface QuoteLogWithLocations
 */
export interface QuoteLogWithLocations {
  /**
   *
   * @type {string}
   * @memberof QuoteLogWithLocations
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof QuoteLogWithLocations
   */
  serviceIdentifier: string;
  /**
   *
   * @type {boolean}
   * @memberof QuoteLogWithLocations
   */
  success: boolean;
  /**
   *
   * @type {string}
   * @memberof QuoteLogWithLocations
   */
  message?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof QuoteLogWithLocations
   */
  createdAt: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof QuoteLogWithLocations
   */
  shipmentId: string;
  /**
   *
   * @type {Location}
   * @memberof QuoteLogWithLocations
   */
  pickupLocation?: Location | null;
  /**
   *
   * @type {Location}
   * @memberof QuoteLogWithLocations
   */
  deliveryLocation?: Location | null;
}

/**
 * Check if a given object implements the QuoteLogWithLocations interface.
 */
export function instanceOfQuoteLogWithLocations(
  value: object,
): value is QuoteLogWithLocations {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (
    !("serviceIdentifier" in value) ||
    value["serviceIdentifier"] === undefined
  )
    return false;
  if (!("success" in value) || value["success"] === undefined) return false;
  if (!("createdAt" in value) || value["createdAt"] === undefined) return false;
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  return true;
}

export function QuoteLogWithLocationsFromJSON(
  json: any,
): QuoteLogWithLocations {
  return QuoteLogWithLocationsFromJSONTyped(json, false);
}

export function QuoteLogWithLocationsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteLogWithLocations {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier: json["carrierIdentifier"],
    serviceIdentifier: json["serviceIdentifier"],
    success: json["success"],
    message: json["message"] == null ? undefined : json["message"],
    createdAt: json["createdAt"],
    shipmentId: json["shipmentId"],
    pickupLocation:
      json["pickupLocation"] == null
        ? undefined
        : LocationFromJSON(json["pickupLocation"]),
    deliveryLocation:
      json["deliveryLocation"] == null
        ? undefined
        : LocationFromJSON(json["deliveryLocation"]),
  };
}

export function QuoteLogWithLocationsToJSON(json: any): QuoteLogWithLocations {
  return QuoteLogWithLocationsToJSONTyped(json, false);
}

export function QuoteLogWithLocationsToJSONTyped(
  value?: QuoteLogWithLocations | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    serviceIdentifier: value["serviceIdentifier"],
    success: value["success"],
    message: value["message"],
    createdAt: value["createdAt"],
    shipmentId: value["shipmentId"],
    pickupLocation: LocationToJSON(value["pickupLocation"]),
    deliveryLocation: LocationToJSON(value["deliveryLocation"]),
  };
}
